import { render, staticRenderFns } from "./printinvoice.vue?vue&type=template&id=48da0c12&"
import script from "./printinvoice.vue?vue&type=script&lang=js&"
export * from "./printinvoice.vue?vue&type=script&lang=js&"
import style0 from "./printinvoice.vue?vue&type=style&index=0&id=48da0c12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports